/** One carousel viewport row: fixed slot count, null = empty placeholder cell. */
export function buildCardCarouselDisplaySlots(
  cards: readonly unknown[] | null | undefined,
  nbDisplayCards: number,
  currentIndex: number,
): (unknown | null)[] {
  const list = cards ?? [];
  const slotCount = Math.max(0, nbDisplayCards);
  const start = Math.max(0, currentIndex);

  return Array.from({ length: slotCount }, (_, offset) => list[start + offset] ?? null);
}

export function cardCarouselGridTemplateColumns(nbDisplayCards: number): string {
  const slotCount = Math.max(0, nbDisplayCards);
  return `repeat(${slotCount}, minmax(0, 1fr))`;
}
